import { assertNever } from '@assetaccountant/core/utils/asset-utils';

export enum SaveAssetType {
  Asset = 0,
  Lease = 1,
  AddAssetToLease = 2,
}

export enum IntegrationType {
  NoIntegration = 0,
  QuickBooks = 1,
  Sage = 2,
  Xero = 3,
  MicrosoftDynamics = 4,
}

export function getIntegrationName(type: IntegrationType) {
  switch (type) {
    case IntegrationType.QuickBooks:
      return 'QuickBooks Online';
    case IntegrationType.NoIntegration:
      return 'Spreadsheet';
    case IntegrationType.Sage:
      return 'Sage Intacct';
    case IntegrationType.Xero:
      return 'Xero';
    case IntegrationType.MicrosoftDynamics:
      return 'Microsoft Dynamics';
    default:
      assertNever(type, 'Unrecognised integration type');
  }
}
